<template>
	<div class="user_wrapper">
		<div class="user_head_outer">
			<div class="user_head" style="position:relative;">
				<div class="head_module1">
					<div class="left">
						<div class="head_image">
							<img :src="imgUrl+'headimage.png'"/>
						</div>
						<div class="user_info">
							<div class="corp_name">
								{{corpInfo.cname}}
							</div>
							<div>
								账户名：{{userInfo.username}} |  部门：{{userInfo.dept}}  |  {{userInfo.user_type===1?'管理员':'普通用户'}}
							</div>
						</div>
					</div>
					<div class="right">
						<div class="user_info">
							<div class="last_logtime">
								上次登录时间：{{userInfo.last_login_time}}
							</div>
							<div style="display: flex;align-items: center;">
                  <div class="transp_btn"  @click="showModifyPWDialog" >
                  	<i  class="cloudicon ci_lock"></i>&nbsp;修改密码
                  </div>
                  <div  class="transp_btn"  @click="logout">
                  	<i class="cloudicon ci_mapback"></i>&nbsp;&nbsp;退出登录
                  </div>
							</div>
						</div>
					</div>
				</div>
				<div class="head_module2">
					<span>企业标签：{{corpSizeStr}}</span>&nbsp;&nbsp;|&nbsp;
					<span>企业类型：{{corpTypeStr}}</span>&nbsp;&nbsp;|&nbsp;
					<span>关注申报类型：{{policyStr}}</span>
				</div>

				<div class="message_outer" >
					<div class="norm" :class="{'fold_style':fold}">
						<div v-if="messageData.length" v-for="(item,index) in messageData" class="message_item" >
							<span class="message_title" :class="{m_dot:item.isread==0}">{{msgType[item.type][1]}}{{item.title}}</span>
							<span class="view_btn" @click="mDetail(item)">查看</span>
						</div>
						<div v-if="!messageData.length">暂无消息通知</div>
					</div>
					<img :src="imgUrl+'message_ring.png'" alt="" class="ring" />
					<img :src="imgUrl+'circle_arrow_d.svg'" class="circle_arrow" v-show="fold" @click="fold=false" />
					<img :src="imgUrl+'circle_arrow_up.svg'" class="circle_arrow" v-show="!fold" @click="fold=true" />
				</div>
			</div>
		</div>

		<div class="user_main_outer">
			<div class="user_main">
				<div class="left_menu">
					<div v-for="(item,index) in menuData">
						<div class="menu_link"  @click="linkTo(item,index)" :class="{'curl':index==curl}">{{item.an}}</div>
						<div v-if="item.an=='数据调查'" v-show="survey">
							<div class="sub_link" v-for="(items,indexs) in item.sub" :class="{'curs':indexs==curs}" @click="linkTo(items,index,indexs)">{{items.an}}</div>
						</div>
						<div v-if="item.an=='人员登记'" v-show="comeleave">
							<div class="sub_link" v-for="(items,indexs) in item.sub" :class="{'curs':indexs==cursCL}" @click="linkTo(items,index,indexs)">{{items.an}}</div>
						</div>
						<div v-if="item.an=='我的关注'" v-show="fav">
							<div class="sub_link" v-for="(items,indexs) in item.sub" :class="{'curs':indexs==cursf}" @click="linkTo(items,index,indexs)">{{items.an}}</div>
						</div>
					</div>
				</div>
				<div class="right_cont_outer">
					<div class="right_head">
						<span style="padding-left: 24px;">当前位置：</span><span class="linkto" @click="tohome">首页</span><img :src="imgUrl+'double_arrow2.png'"/><span class="cur">{{curmenu}}</span>
					</div>
					<div class="right_cont">
    					<router-view></router-view>
					</div>
				</div>
			</div>
		</div>
	  <el-dialog
      title="修改密码"
      :visible.sync="dialogVisibleModifyPW"
      width="30%">

      <div class="change_dialog">
        <div>
          <el-input placeholder="请输入旧密码" v-model="oldpw" show-password></el-input>
        </div>
        <div style="margin: 20px 0;">
          <el-input placeholder="请输入新密码" v-model="newpw" show-password></el-input>
        </div>
        <div>
          <el-input placeholder="请再次输入新密码" v-model="newpw2" show-password></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="submitModifyPW">确 定</el-button>
		    <el-button @click="dialogVisibleModifyPW = false">取 消</el-button>
		  </span>
    </el-dialog>
	</div>

</template>

<script>
	import Qs from 'qs'
	export default{
		name:'user',
		data(){
			return {
				curmenu:'用户中心',
				menuData: [{an:'用户中心',links:'user'},{an:'申报项目',links:'userproject'},{an:'数据调查',links:'usersurvey',sub:[{an:'产出预测',links:'usersurvey',i:'0'},{an:'产业用地调查',links:'usersurvey2',i:'1'}]},{an:'我有诉求',links:'userappeal'},{an:'企业走访',links:'uservisit'},{an:'人员登记',links:'userclfx',sub:[{an:'离奉人员登记',links:'userclfx',i:'0'},{an:'来奉人员登记',links:'userclfx2',i:'1'}]},{an:'我的关注',links:'userfav',sub:[{an:'申报关注',links:'userfav',i:'0'},{an:'政策关注',links:'userfav2',i:'1'}]},{an:'账户设置',links:'userset'},{an:'用户管理',links:'usermanage'}],
				curl:0,
				curs:null,
				cursf:null,
				cursCL:null,
				survey:false,
				fav:false,
				comeleave:false,
		        userInfo:{},
		        corpInfo:{},
		        corpTag:{
		          corp_type:[],
		          corpsize:[],
		          policy:[]
		        },
		        corpSizeStr:'',
		        corpTypeStr:'',
		        policyStr:'',
		        oldpw: '',
		        newpw: '',
		        newpw2: '',
				dialogVisibleModifyPW: false,
				messageData:[],
				fold:true,
				msgType:{'1':['userproject','申报通知：'],'2':['userappeal','诉求通知：'],'3':['uservisit','走访通知：'],'4':['notice','']}
			}
		},
		inject: ['reload'],
		created(){
			let roleId = JSON.parse(localStorage.getItem('gyzhqy_user_info')).role_id
			let userType = JSON.parse(localStorage.getItem('gyzhqy_user_info')).user_type
			if(userType==2){
				this.menuData = this.menuData.filter(res=>{return res.an!='用户管理'})
				if(roleId.indexOf(1)<0){
					this.menuData = this.menuData.filter(res=>{return res.an!='数据调查'})
				}
				if(roleId.indexOf(2)<0){
					this.menuData = this.menuData.filter(res=>{return res.an!='申报项目'})
				}
				if(roleId.indexOf(3)<0){
					this.menuData = this.menuData.filter(res=>{return res.an!='我有诉求'})
				}
				if(roleId.indexOf(4)<0){
					this.menuData = this.menuData.filter(res=>{return res.an!='企业走访'})
				}
				if(roleId.indexOf(5)<0){
					this.menuData = this.menuData.filter(res=>{return res.an!='人员登记'})
				}
			}
			this.getMessage()
		    this.getCorpInfo()
		},
		watch:{
			$route(to,from){
				this.linkChange(to.name)
			}
		},
		methods:{
			linkTo(item,index,indexs){
				this.curs=null;
				this.cursf=null;
				this.cursCL=null;
				this.survey=false;
				this.fav=false;
				this.comeleave=false;
				this.curl=index;
				this.$router.replace(item.links)
				if(item.links.indexOf('survey')>-1){
					this.survey=true;
					this.curs=indexs||0;
					if(item.sub){
						this.$router.replace(item.sub[0].links)
					}
				}
				if(item.links.indexOf('clfx')>-1){
					this.comeleave=true;
					this.cursCL=indexs||0;
				}
				if(item.links.indexOf('fav')>-1){
					this.fav=true;
					this.cursf=indexs||0;
				}
			},
			linkChange(n){
				this.menuData.forEach(function(item,index){
					if(item.links.indexOf(n)>-1||n.indexOf(item.links)>-1){
						this.curl=index
						this.curmenu=item.an
					}
				},this)
				if(n=='usercenter'){this.curmenu='用户中心'}
			},
			tohome(){
				this.$router.replace({name:'homepage'})
			},
			logout(){
				window.localStorage.setItem('gyzhqy_token',null);
				window.localStorage.setItem('gyzhqy_corp_info',null);
				window.localStorage.setItem('gyzhqy_corp_tag',null);
				window.localStorage.setItem("gyzhqy_user_info",null)
				this.$store.commit('mcn','登录');
				this.$router.push({path:'/'})
			},

			showModifyPWDialog(){
				this.oldpw='';
				this.newpw='';
				this.confirm_password='';
				this.dialogVisibleModifyPW = true;
			},
			getMessage(){
				this.$ajax.post(this.bUrl+'api/portal/notice/lists')
				.then(function(res) {
					if(res.data.code==200){
						this.messageData = res.data.data.list.filter(r=>{return r.isread==0})
					}
				}.bind(this))
				.catch(function(error) {
					console.log(error);
				});
			},

			async submitModifyPW() {
				if(this.newpw==='') {
					this.$message.error("新密码不能为空");
					return;
				}
				if(this.newpw!==this.newpw2){
					this.$message.error("两次输入密码不一致");
					return;
				}
				let data = {
					old_password: this.oldpw,
					password: this.newpw,
					confirm_password: this.newpw2
				}
				let res = await this.$ajax.post(this.bUrl + 'api/user/profile/changePassword', data);
				if (res.data.code == 200) {
					this.$message.success(res.data.msg);
					this.dialogVisibleModifyPW = false
					this.reload()
				} else {
					this.$message.error(res.data.msg);
				}
	    	},
	      	async getCorpInfo() {
		        let res01 = await this.$ajax.get(this.bUrl + 'api/portal/user/getCorpInfo');
		        window.localStorage.setItem("gyzhqy_corp_info", JSON.stringify(res01.data.data))
//		        this.$store.commit('mcn',res01.data.data.cname);
		        let res02 = await this.$ajax.get(this.bUrl + 'api/portal/user/tags');
		        window.localStorage.setItem("gyzhqy_corp_tag", JSON.stringify(res02.data.data))
		        let corpSizeList={1:"大型", 2:"中型", 3:"小型", 4:"微型"};
		        let policyList={1:"创业引导",2:"研发转化", 3:"企业创新", 4:"先进制造业发展", 5:"现代服务业发展", 6:"节能环保", 7:"知识产权和品牌建设", 8:"投融资扶持", 9:"其他产业"};
		        let corpTypeList= {
		          1: "“三个一百”企业",
		          2: "现代服务业",
		          3: "“智能网联新能源企业”产业",
		          4: "“美丽健康”产业",
		          5: "“战略性新兴”产业",
		          6: "“四新”企业",
		          7: "“规模以上（年产值超2000万元）”企业 ",
		          8: "“高新技术”、“科技小巨人”等科技企业",
		          9: "“专精特新”企业",
		          10: "计划IPO企业"
		        };

		        this.linkChange(this.$route.name);
		        if(JSON.parse(window.localStorage.getItem("gyzhqy_corp_info"))!=null){
		          this.corpInfo=JSON.parse(window.localStorage.getItem("gyzhqy_corp_info"));
		        }
		        if(JSON.parse(window.localStorage.getItem("gyzhqy_user_info"))!=null){
		          this.userInfo= JSON.parse(window.localStorage.getItem("gyzhqy_user_info"));
		          this.$store.commit('mcn',this.userInfo.username);
		        }
		        if(JSON.parse(window.localStorage.getItem("gyzhqy_corp_tag"))!=null){
		          this.corpTag=JSON.parse(window.localStorage.getItem("gyzhqy_corp_tag"));
		          let list01= this.corpTag.corp_type;
		          let list02=this.corpTag.corpsize;
		          let list03=this.corpTag.policy;
		          this.corpSizeStr=  list02.map(item=>corpSizeList[item]).join(',');
		          this.corpTypeStr=list01.map(item=>corpTypeList[item]).join(',');
		          this.policyStr=list03.map(item=>policyList[item]).join(',');
		        }
				let jjyx = this.corpInfo.jjyx
				if(jjyx!=1){
					this.menuData.forEach(function(t,i){
						if(t.sub){
							if(t.sub[0].an=='产出预测'){
								t.sub.splice(0,1)
							}
						}
					})
				}
	      	},
			mDetail(item){
				let t = this.msgType[item.type][0]
				window.scrollTo(0, 200);
				if(t=='notice'){
					this.$router.push({path: '/notice'})
				}else{
					this.$router.push({name:t})
				}
				this.msgRead(item)
			},
			msgRead(item){
				this.$ajax.post(this.bUrl+'api/portal/notice/read',{ id: item.id })
				.then(function(res) {
					if(res.data.code==200){
						item.isread=1
					}
				}.bind(this))
				.catch(function(error) {
					console.log(error);
				});
			}
		}
	}
</script>

<style scoped>
	.user_head_outer{
		width: 100%;
		margin-top: 109px;
		height: 263px;
		background: url('/gyzhqyimgs/user_bg.png') center center ;
	}
	.user_head{
		width: 1180px;
		margin:0 auto;
		color: #fff;
	}
	.head_module1{
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 131px;
		padding:32px 16px;
		box-sizing: border-box;
		border-bottom:1px solid rgba(255,255,255,.5);
	}
	.head_module1 .left{
		display: flex;
		align-items: center;
	}
	.head_image{
		margin-right: 44px;
	}
	.user_info .last_logtime{
		margin-bottom: 16px;
		font-size: 14px;
	}
	.user_info .corp_name{
		margin-bottom: 16px;
		font-size: 18px;
	}
	.ci_lock {
	  font-size: 24px;
	  margin-bottom: -2px;
	}

	.ci_mapback {
	  font-size: 18px;
	}
	.transp_btn{
		height: 28px;
		box-sizing: border-box;
		font-size: 14px;
		padding:0 13px 1px 10px;
		border:1px solid #fff;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
		margin-right: 10px;
	}
	.transp_btn:hover{
		border: 1px solid rgba(255,255,255,.5);
	}
	.head_module2{
		height: 131px;
		padding:22px 16px;
		box-sizing: border-box;
	}
	.user_main{
		width: 1180px;
		margin:-50px auto;
		display: flex;
		position: relative;
	}
	.user_main .left_menu{
		width: 260px;
		background: #fff;
		border-radius: 5px;
		padding:14px 34px;
		box-sizing: border-box;
		line-height: 40px;
	}
	.menu_link{
		border-bottom: 3px solid transparent;
		cursor: pointer;
		color: #6F88AF;
		font-size: 16px;
	}
	.sub_link{
		padding-left: 32px;
		color: #6F88AF;
		cursor: pointer;
	}
	.sub_link.curs{
		color:  #3A9FFF;
	}
	.menu_link.curl{
		color: #3A9FFF;
		border-bottom: 3px solid #36A0FF;
	}
	.right_head{
		margin-top: 14px;
		height: 36px;
		line-height: 36px;
		width: 920px;
		background: linear-gradient(to right,rgba(0,108,147,.3),rgba(0,88,255,0),rgba(0,88,255,0));
		color: #fff;
	}
	.right_head img{
		margin: 0 10px;
	}
	.right_head .linkto{
		cursor: pointer;
	}
	.right_head .cur{
		color: rgba(255,255,255,.6);
	}
	.right_cont{
		width: 920px;
		padding:22px;
		/*background: #ff0;*/
	}
	.message_outer{
		width:300px;
		position:absolute;
		z-index: 1;
		bottom:10px;right:10px;
		padding:10px 40px 10px 60px;
		background:rgba(0,0,0,.36);
		border-radius:10px;
		font-size: 14px;
		line-height: 28px;
	}
	.message_outer .norm{
		width:100%;
		max-height: 84px;
		overflow: auto;
	}
	.message_outer .fold_style{
		height:28px;
		overflow: hidden;
	}
	.message_item{
		display: flex;
		align-items: center;
	}
	.message_title{
		display: inline-block;
		width: 230px;
		height: 28px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.message_outer .ring{
		position: absolute;
		top: -10px;
		left: 10px;
	}
	.message_outer .circle_arrow{
		position: absolute;
		top: 10px;
		right: 10px;
		cursor: pointer;
	}
	.view_btn{
		color:#00C4FF;
		margin-left: 10px;
		cursor: pointer;
	}
	.message_outer ::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	.message_outer ::-webkit-scrollbar-thumb {
		border-radius: 5px;
		background: rgba(255, 255, 255, 0.4);
	}

	.message_outer ::-webkit-scrollbar-track {
		border-radius: 5px;
		background: rgba(255, 255, 255, 0.2);
	}
	.m_dot{
		position: relative;
	}
	.m_dot:after{
		content:'';
		position:absolute;
		top: 0px;
		right:0;
		width: 7px;
		height: 7px;
		background:red;
		border-radius: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/user/index.vue